<template>
  <div class="wxQrCode">
    <div class="wxQrCode-con">
      <div class="wxQrCode-image">
        <img :src="wxQrCodeUrl" alt="">
      </div>
      <div class="wxQrCode-tips"><img src="https://resource.rcclchina.com.cn/wechatMiniProgram/bidding/scan-code-icon.png" alt="">使用微信扫码，开启竞价升房</div>
      <div class="wxQrCode-close" @click="closePopup">
        <img src="https://resource.rcclchina.com.cn/invoice/popupClose-icon.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "StateRoomQrCodePopup",
  props: {
    wxQrCodeUrl:{
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  },
  methods: {
    closePopup () {
      this.$emit('closePopup')
    }
  }
}
</script>

<style scoped lang="less">
.wxQrCode {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 99;

  .wxQrCode-con {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    height: 365px;
    background: #fff;
    border-radius: 20px;

    .wxQrCode-image {
      width: 255px;
      height: 255px;
      margin: 40px auto 0;

      img {
        width: 100%;
      }
    }

    .wxQrCode-tips {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #272636;
      margin-top: 20px;
      gap: 10px;

      img {
        width: 30px;
        height: 28px;
        display: block;
      }
    }

    .wxQrCode-close {
      position: absolute;
      width: 22px;
      height: 22px;
      right: 20px;
      top: 20px;
      cursor: pointer;

      img {
        width: 100%;
      }
    }
  }
}
</style>